import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

interface CollapsibleSectionProps {
  title: string;
  children: React.ReactNode;
  defaultOpen?: boolean;
}

export const CollapsibleSection: React.FC<CollapsibleSectionProps> = ({
  title,
  children,
  defaultOpen = false
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <div className="rounded-2xl border border-primary/10 bg-white px-5 py-4 md:px-6">
      <button 
        onClick={() => setIsOpen(!isOpen)}
        className="group flex w-full justify-between text-left"
        aria-expanded={isOpen}
      >
        <span className="text-lg font-semibold text-ink transition-colors group-hover:text-primary md:text-xl">
          {title}
        </span>
        <ChevronDown
          className={`h-5 w-5 text-slate-500 transition-transform duration-300 ${
            isOpen ? 'rotate-180' : ''
          }`}
        />
      </button>
      
      <div 
        className={`overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? 'mt-4 max-h-[2000px] opacity-100' : 'mt-0 max-h-0 opacity-0'
        }`}
      >
        <div className="prose max-w-none space-y-4 text-slate-700">
          {children}
        </div>
      </div>
    </div>
  );
};

export default CollapsibleSection;
